function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var AdminKeyUI = require('./adminkey');
var AdminSetup = require('./setup');
var AdminOverviewUI = require('./overview');
var AdminTokensUI = require('./tokens');
var AdminModulesUI = require('./modules');
var AdminPeersUI = require('./peers');
var AdminDatabaseUI = require('./database');
var AdminBlocksUI = require('./blocks');
var AdminMempoolUI = require('./mempool');
var AdministratorsUI = require('./administrators');
var AdminMain = /*#__PURE__*/function () {
  function AdminMain(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.saito-container';
    _classCallCheck(this, AdminMain);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.mode = '';
    this.current_view = 'overview';
    this.shell_rendered = false;
    this.adminkey_ui = new AdminKeyUI(app, mod);
    this.setup_ui = new AdminSetup(app, mod);
    this.overview_ui = new AdminOverviewUI(app, mod);
    this.tokens_ui = new AdminTokensUI(app, mod);
    this.modules_ui = new AdminModulesUI(app, mod);
    this.peers_ui = new AdminPeersUI(app, mod);
    this.database_ui = new AdminDatabaseUI(app, mod);
    this.blocks_ui = new AdminBlocksUI(app, mod);
    this.mempool_ui = new AdminMempoolUI(app, mod);
    this.administrators_ui = new AdministratorsUI(app, mod);
  }
  return _createClass(AdminMain, [{
    key: "hasAdminKey",
    value: function hasAdminKey() {
      return !need_to_set_key;
    }
  }, {
    key: "isSetupComplete",
    value: function isSetupComplete() {
      var _this$mod$server_info, _this$mod$server_info2;
      if (((_this$mod$server_info = this.mod.server_info) === null || _this$mod$server_info === void 0 || (_this$mod$server_info = _this$mod$server_info.options) === null || _this$mod$server_info === void 0 ? void 0 : _this$mod$server_info.isSetupComplete) === true) {
        return true;
      }
      if (typeof is_setup_complete !== 'undefined' && is_setup_complete === true) {
        return true;
      }
      if ((_this$mod$server_info2 = this.mod.server_info) !== null && _this$mod$server_info2 !== void 0 && (_this$mod$server_info2 = _this$mod$server_info2.options) !== null && _this$mod$server_info2 !== void 0 && _this$mod$server_info2.defaultModule) {
        return true;
      }
      if (typeof default_module !== 'undefined' && default_module) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.current_view;
      this.overview_ui.network_ui.destroy();
      if (!this.hasAdminKey()) {
        this.mode = 'adminkey';
        this.shell_rendered = false;
        this.adminkey_ui.render();
        return;
      }
      if (!this.isSetupComplete() || this.setup_ui.showing_recompile) {
        if (this.mode !== 'setup') {
          this.mode = 'setup';
          this.shell_rendered = false;
          this.setup_ui.render();
        }
        return;
      }
      this.mode = 'app';
      this.current_view = view;
      this.renderShell();
      this.syncTokensNav();
      if (view === 'tokens' && !this.isLocalDevelopment()) {
        view = 'overview';
        this.current_view = view;
      }
      this.showPage(view);
      if (view === 'overview') {
        this.overview_ui.render();
      }
      if (view === 'tokens') {
        this.tokens_ui.render();
      }
      if (view === 'modules') {
        this.modules_ui.render();
      }
      if (view === 'peers') {
        this.peers_ui.render();
      }
      if (view === 'database') {
        this.database_ui.render();
      }
      if (view === 'blocks') {
        this.blocks_ui.render();
      }
      if (view === 'mempool') {
        this.mempool_ui.render();
      }
      var sidebar = this.sidebarPanel(view);
      if (sidebar) {
        sidebar.render();
      }
      if (view === 'administrators') {
        this.administrators_ui.render();
      }
    }
  }, {
    key: "isLocalDevelopment",
    value: function isLocalDevelopment() {
      var _this$mod$server_info3;
      return ((_this$mod$server_info3 = this.mod.server_info) === null || _this$mod$server_info3 === void 0 || (_this$mod$server_info3 = _this$mod$server_info3.options) === null || _this$mod$server_info3 === void 0 || (_this$mod$server_info3 = _this$mod$server_info3.consensus) === null || _this$mod$server_info3 === void 0 ? void 0 : _this$mod$server_info3.disable_block_production) === false;
    }
  }, {
    key: "syncTokensNav",
    value: function syncTokensNav() {
      var nav = document.querySelector('.saito-admin-nav-item[data-admin-view="tokens"]');
      if (nav) {
        nav.hidden = !this.isLocalDevelopment();
      }
    }
  }, {
    key: "renderShell",
    value: function renderShell() {
      if (this.shell_rendered && document.querySelector('.saito-admin-main')) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(MainTemplate(this.app, this.mod), this.container);
      this.shell_rendered = true;
      this.attachEvents();
    }
  }, {
    key: "showPage",
    value: function showPage(view) {
      document.querySelectorAll('.admin-page').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelectorAll('.saito-admin-nav-item').forEach(function (el) {
        el.classList.remove('active');
      });
      var page = document.querySelector(".admin-page.admin-".concat(view));
      if (page) {
        page.style.display = 'block';
      }
      var nav = document.querySelector(".saito-admin-nav-item[data-admin-view=\"".concat(view, "\"]"));
      if (nav) {
        nav.classList.add('active');
      }
    }

    // Installed modules contribute a panel with respondTo('admin-sidebar'):
    // { id, name, render }. Clicking the entry calls render().
  }, {
    key: "sidebarPanels",
    value: function sidebarPanels() {
      var _this$app$modules$get, _this$app$modules;
      return (((_this$app$modules$get = (_this$app$modules = this.app.modules).getRespondTos) === null || _this$app$modules$get === void 0 ? void 0 : _this$app$modules$get.call(_this$app$modules, 'admin-sidebar')) || []).filter(function (panel) {
        return panel && typeof panel.render === 'function' && panel.name && /^[a-z0-9_-]+$/i.test(String(panel.id || ''));
      });
    }
  }, {
    key: "sidebarPanel",
    value: function sidebarPanel(view) {
      return this.sidebarPanels().find(function (panel) {
        return panel.id === view;
      }) || null;
    }
  }, {
    key: "backTarget",
    value: function backTarget() {
      // Referrers do not reliably describe the preceding history entry (e.g. after Back).
      try {
        var navigation = window.navigation;
        var previous = navigation === null || navigation === void 0 ? void 0 : navigation.entries()[navigation.currentEntry.index - 1];
        if (previous !== null && previous !== void 0 && previous.url) {
          var url = new URL(previous.url);
          if (url.host === window.location.host && /^https?:$/.test(url.protocol)) {
            return {
              url: url.href,
              useHistory: true
            };
          }
        }
      } catch (err) {
        // Older browsers cannot expose the previous history URL.
      }
      return {
        url: '/',
        useHistory: false
      };
    }
  }, {
    key: "syncToolbar",
    value: function syncToolbar() {
      var link = document.querySelector('.saito-admin-back');
      if (link) {
        var target = this.backTarget();
        var label = target.useHistory ? 'Go back' : 'Go to site home';
        link.setAttribute('href', target.url);
        link.setAttribute('aria-label', label);
        link.title = label;
        link.querySelector('i').hidden = !target.useHistory;
        link.querySelector('img').hidden = target.useHistory;
      }
      var toggle = document.getElementById('admin-dark-mode');
      if (toggle) {
        var dark = document.documentElement.getAttribute('data-admin-theme') === 'dark';
        var _label = dark ? 'Switch to light mode' : 'Switch to dark mode';
        toggle.setAttribute('aria-pressed', String(dark));
        toggle.setAttribute('aria-label', _label);
        toggle.title = _label;
        toggle.querySelector('i').className = "fa-solid ".concat(dark ? 'fa-sun' : 'fa-moon');
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      this.syncToolbar();
      if (!this.toolbar_history_handler) {
        var _window$navigation, _window$navigation$ad;
        this.toolbar_history_handler = function () {
          return _this.syncToolbar();
        };
        (_window$navigation = window.navigation) === null || _window$navigation === void 0 || (_window$navigation$ad = _window$navigation.addEventListener) === null || _window$navigation$ad === void 0 || _window$navigation$ad.call(_window$navigation, 'currententrychange', this.toolbar_history_handler);
        window.addEventListener('pageshow', this.toolbar_history_handler);
        window.addEventListener('popstate', this.toolbar_history_handler);
      }
      var link = document.querySelector('.saito-admin-back');
      if (link) {
        link.onclick = function (event) {
          _this.syncToolbar();
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
          }
          if (_this.backTarget().useHistory) {
            event.preventDefault();
            window.history.back();
          }
        };
      }
      var darkMode = document.getElementById('admin-dark-mode');
      if (darkMode) {
        darkMode.onclick = function () {
          var theme = document.documentElement.getAttribute('data-admin-theme') === 'dark' ? 'light' : 'dark';
          document.documentElement.setAttribute('data-admin-theme', theme);
          _this.syncToolbar();
          try {
            window.localStorage.setItem('saito-admin-theme', theme);
          } catch (err) {
            // The appearance still changes when browser storage is unavailable.
          }
        };
      }
      document.querySelectorAll('[data-admin-view]').forEach(function (el) {
        el.onclick = function (e) {
          var view = e.currentTarget.getAttribute('data-admin-view');
          _this.render(view);
        };
      });
    }
  }]);
}();
module.exports = AdminMain;